import { Router } from '@angular/router';
import { Component, OnInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { ProductsService } from '../../../../services/products.service';
import { ClientTransactionView } from 'src/app/models/products/transactions';
import { TransactionsService } from 'src/app/services/transactions.service';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit, AfterViewChecked, OnDestroy {

  localStorageFiles: Array<any>;
  showUploadFileWindow = false;
  files = [];
  clientTransactionItems: Array<ClientTransactionView>;
  renderFileIpload = true;
  currentProdIndex = 0;
  maxFilesize = 50000000; // 50mb
  maxFilesSizeCombined = 500000000; // 500mb
  allowedFileTYpes = ['pdf', 'jpg', 'png', 'dwg', 'jpeg', 'zip', 'rar'];
  displayError = false;
  errorFileName = '';
  filesSrcBase64 = [];
  displayErrorSize = false;
  subscription: any;
  private _isComponentActive = true;

  constructor(
    private _transactionsService: TransactionsService,
    private _router: Router) {
    this._transactionsService.clientTransactionsView$
    .pipe(takeWhile(()=>this._isComponentActive))
    .subscribe(transactions=>{
      this.clientTransactionItems = transactions;
    });
    this.subscription = this._router.events.subscribe((event) => {
      if (!this._router.navigated && (<any>localStorage).fileListArr) {
        this.localStorageFiles = JSON.parse((<any>localStorage).fileListArr);
        if (this.localStorageFiles && this.localStorageFiles.filter(x=>x && x.find(y=>y.length>0)).length >0  && this._transactionsService.fileList.data.items.length===0) {
          this.showUploadFileWindow = true;
          this.setFilesArray();
        }
      }
    });
  }

  ngOnInit() {
    
  }

  ngAfterViewChecked() {
    if (this.localStorageFiles && 
      this.localStorageFiles.length && 
      this.localStorageFiles.find(x=>x.length) &&
      this.localStorageFiles.length !== this._transactionsService.fileList.data.items.length) {
      document.querySelector('.anim-to-disable')?.classList.add('disable-anim');
    }
  }
  
  approve() {
    this._transactionsService.fileList.data.items = this.files;
    if (this.checkFilesValidity()) {
      this.showUploadFileWindow = false;
      document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
    }
  }

  checkFilesValidity() {
    this.displayErrorSize = false;
    let res = true;
    let filesSize = 0;
    if (this.files != null) {
      for (let i = 0; i < this.files.length; i++) {
        for (let j = 0; j < this.files[i].length; j++) {
          const fileExt = this.files[i][j].name.split('.').pop().toLowerCase();
          filesSize += this.files[i][j].size;
          if (this.files[i][j].size > this.maxFilesize || this.allowedFileTYpes.indexOf(fileExt) < 0) {
            res = false;
          }
        }

      }
    }
    if (filesSize > this.maxFilesSizeCombined) {
      res = false;
    }
    if (!res) {
      this.displayErrorSize = true;
    }
    return res;
  }

  setFilesArray() {
    this.clientTransactionItems.forEach(() => {
      this.files.push([]);
      this.filesSrcBase64.push([]);
    });
  }

  upload(event) {
    this.displayError = false;
    this.errorFileName = '';
    for (let i = 0; i < event.target.files.length; i++) {
      if (this.validateFile(event.target.files[i])) {
        this.files[this.currentProdIndex].push(event.target.files[i]);
        const fileExt = this.files[this.currentProdIndex][this.files[this.currentProdIndex].length - 1].name.split('.').pop().toLowerCase();
        if (fileExt === 'dwg' || fileExt === 'pdf') {
          this.filesSrcBase64[this.currentProdIndex].push(fileExt);
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(this.files[this.currentProdIndex][this.files[this.currentProdIndex].length - 1]);
          reader.onload = () => {
            this.filesSrcBase64[this.currentProdIndex].push(reader.result);
          };
        }
      } else {
        if (this.errorFileName.length > 0) {
          this.errorFileName += ',' + event.target.files[i].name;
        } else {
          this.errorFileName = event.target.files[i].name;
        }
      }
    }
  }

  getFileExtension(i, fileIndex){
    return this.files[i][fileIndex].name.split('.').pop().toLowerCase();
  }

  validateFile(file) {
    let res = true;
    const fileExt = file.name.split('.').pop().toLowerCase();
    if (file.size > this.maxFilesize || this.allowedFileTYpes.indexOf(fileExt) < 0) {
      res = false;
      this.displayError = true;
    }
    return res;
  }

  selectFile(currentProdIndex) {
    (document.querySelector('#upload-file-list') as HTMLInputElement).click();
    this.currentProdIndex = currentProdIndex;
  }

  removeFile(fileIndex, prodIndex) {
    const newFileList = [];
    for (let i = 0; i < this.files[prodIndex].length; i++) {
      if (i !== fileIndex) {
        newFileList.push(this.files[prodIndex][i]);
      }
    }
    this.files[prodIndex] = newFileList;
    this.renderFileIpload = false;
    window.setTimeout(() => {
      this.renderFileIpload = true;
    }, 500);
  }

  ngOnDestroy(){
    this._isComponentActive = false;
    this.subscription.unsubscribe();
  }
}
